import { createTheme } from '@material-ui/core';

// Used only when this microfrontend runs outside the Witboost container.
// When embedded, Witboost passes its real theme through the render contract.
// Keep local compatibility tweaks here until a shared Witboost component/theme
// package exists and can replace the local WbStubs compatibility layer.
export const standaloneTheme = createTheme({});
